var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.523.8a1.61 1.61 0 0 1 1.723.036l10.125 6.152c.492.317.809.88.809 1.442 0 .597-.317 1.16-.809 1.441L3.246 16.06c-.527.316-1.195.351-1.723.035-.527-.282-.843-.844-.843-1.477V2.242c0-.597.316-1.16.843-1.441m.844 13.817L12.492 8.43 2.367 2.242z"
  })));
};
export default SvgPlay;